import Swiper, { Navigation, Lazy } from 'swiper';
import BaseComponent from 'scripts/BaseComponent.js';

export default class EmptyCartRecommendations extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      swiperContainer: '.js-emptyCartRecommendations',
      prevArrow: '.js-emptyCartRecommendationsPrev',
      nextArrow: '.js-emptyCartRecommendationsNext',
      swiperSlide: '.js-slide',
      blockTitle: '.js-blockTitle',
      blockMax: '.js-blockMax',
      blockMin: '.js-blockMin',
      cartTotal: '.js-cartTotal',
      cartItem: '.CartItem',
    };

    this.dom = {
      $component: component,
      $swiperContainer: this.$get(this.refs.swiperContainer),
      $prevArrow: this.$get(this.refs.prevArrow),
      $nextArrow: this.$get(this.refs.nextArrow),
      $swiperSlides: this.$get(this.refs.swiperSlide),
      $blockTitles: this.$get(this.refs.blockTitle),
      $cartTotal: document.querySelector(this.refs.cartTotal),
      $cartItems: document.querySelectorAll(this.refs.cartItem),
    };

    this.state = {
      swiper: null,
      mountCartItemsTotals: 'mountcarttotals',
      numSteps: 0,
      currentStep: 0,
      stepIndices: {},
      stepConstraints: [],
    };

    this.mount();
    this.init();
  }

  mount() {
    super.mount();
  }

  init() {
    this.initSlider();
  }

  initSlider() {
    const { dom, state } = this;

    state.swiper = new Swiper(dom.$swiperContainer, {
      modules: [Navigation, Lazy],
      preloadImages: false,
      slidesPerView: 2,
      spaceBetween: 0,
      centeredSlides: false,
      threshold: 5,
      navigation: {
        prevEl: dom.$prevArrow,
        nextEl: dom.$nextArrow,
      },
      lazy: {
        loadOnTransitionStart: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
      },
    });
  }
}
